import { FlowExecutionData } from "../../Engine/FlowExecutionData";
import { LongOutputTestStep } from "./LongOutputTestStep";
import { FlowStepRunner } from "../FlowStepRunner";
import { IUserInfo } from "../../../Plugins/DataStorage/IUserInfo";
import { FlowEngine } from "../../Engine/FlowEngine";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../Structure/FlowTestingContext";

export class LongOutputTestStepRunner extends FlowStepRunner<LongOutputTestStep> {
    async start(
        _user: IUserInfo,
        _thread: string,
        _executionData: ExecutionData,
        _flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void> {
        await FlowEngine.stepComplete(
            _user,
            _flowExecutionData,
            _thread,
            this.stepData!,
            this.stepData!.paths[0],
            testContext
        );
    }
}
